import {CtModelRouteData} from "@ctsolution/ct-framework";

export const WorkOrderRowContactRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("workorderrowcontact");
